export type GeofenceShapeTypeName = "Circle" | "Rectangle" | "Polygon";

export enum GeofenceShapeType {
    Circle = 1,
    Rectangle = 2,
    Polygon = 3,
}

export interface CircleShapeData {
    centerLat: number;
    centerLng: number;
    radiusMeters: number;
}

export interface RectangleShapeData {
    northEastLat: number;
    northEastLng: number;
    southWestLat: number;
    southWestLng: number;
}

export interface PolygonShapeData {
    points: { lat: number; lng: number }[];
}

export interface GeofenceDto {
    geofenceId: string;
    name: string;
    description?: string;
    customerId?: string;
    customerName?: string;
    costCenterId?: string;
    costCenterName?: string;
    shapeType: GeofenceShapeType;
    shapeData: string; // JSON string — parse to CircleShapeData | RectangleShapeData | PolygonShapeData
    rowId?: string; // Base64 rowversion for optimistic concurrency
}

export interface SaveGeofenceDto {
    geofenceId?: string;
    name: string;
    description?: string;
    customerId?: string;
    costCenterId?: string;
    shapeType: GeofenceShapeType;
    shapeData: string;
    rowId?: string; // Sent on update to detect concurrent modifications
}

export const parseShapeData = (geofence: GeofenceDto): CircleShapeData | RectangleShapeData | PolygonShapeData | null => {
    try {
        return JSON.parse(geofence.shapeData);
    } catch {
        return null;
    }
};
